import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Fade from 'react-reveal/Fade';
import styled from 'styled-components';
import boost from '../assets/boost.png';
import invite from '../assets/invite.png';
import blob from '../assets/phoneBlob.png';
import phone from '../assets/phoneBottom.png';
import rewards from '../assets/rewards.png';
import widget from '../assets/widget.png';
const Phone = () => {
    return (_jsxs(Layout, { children: [_jsx(Blob, { src: blob }), _jsx(Layer, { children: _jsx(Fade, { bottom: true, children: _jsx("img", { src: phone }) }) }), _jsx(Layer, { children: _jsx(Fade, { bottom: true, delay: 200, children: _jsx("img", { src: widget }) }) }), _jsx(Layer, { children: _jsx(Fade, { bottom: true, delay: 500, children: _jsx("img", { src: boost }) }) }), _jsx(Layer, { children: _jsx(Fade, { bottom: true, delay: 800, children: _jsx("img", { src: invite }) }) }), _jsx(Layer, { children: _jsx(Fade, { bottom: true, delay: 1100, children: _jsx("img", { src: rewards }) }) })] }));
};
const Layout = styled.div `
  position: relative;
  z-index: 1;
  margin: 0 auto -120px;

  img {
    width: 100%;
  }
`;
const Blob = styled.img `
  position: relative;
  z-index: 99;
`;
const Layer = styled.div `
  position: absolute;
  top: 0;
  left: 0;
`;
export default Phone;
